<template>
	<div>
		<trainSearch title="考试中心" :isSearch="true"></trainSearch>
		<div class="container">
			<div style="display: flex;flex-direction: column;height: 3.75rem;margin: 0 2rem">
				<div  @click="selectedItem=999" :class="selectedItem==999?'selectedItem profileHover':'profileHover'" style="cursor: pointer; background-color: #FFFFFF; border-radius: 0.25rem;width: 240px;
				height: 54px;font-size: 1rem;padding: 0.9375rem;margin-bottom:0.3125rem;">
							全部
						</div>
				<div v-for="(item,index) in SelExamPaperTypeData" @click="selectedItem=item.examPaperTypeId" :class="selectedItem==item.examPaperTypeId?'selectedItem profileHover':'profileHover'" style="cursor: pointer; background-color: #FFFFFF; border-radius: 0.25rem;width: 240px;
		height: 54px;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					{{item.title}}
				</div>
				<!-- <div @click="selectedItem=2" :class="selectedItem==2?'selectedItem profileHover':'profileHover'" style="cursor: pointer; background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
		height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					动物实验资格证考试
				</div>
				<div @click="selectedItem=3" :class="selectedItem==3?'selectedItem profileHover':'profileHover'" style="cursor: pointer; background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
		height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					专业知识考试
				</div> -->
			</div>
			<div style="width: 892px;
				">
				<examCard   v-show="selectedItem==999" :id="'空白'"  ></examCard>
				<examCard v-for="(item,index) in SelExamPaperTypeData"  v-show="selectedItem==item.examPaperTypeId" :id="item.examPaperTypeId"  ></examCard>
				<!-- <examCard :length="animalCount" v-show="selectedItem==2" :id="'1'" :data="animalData"  ></examCard>
				<examCard :length="knowCount" v-show="selectedItem==3" :id="'3'" :data="knowledgeData"  ></examCard> -->
			</div>
		</div>
	</div>


</template>

<script>
	import {SelExamPaper,SelExamPaperType} from '@/api/index.js'
	import trainSearch from '../../components/trainSearch.vue'
	import examCard from '../../components/examCard.vue'
	export default {
		name:'/exam',
		components: {
			trainSearch,
			examCard
		},
		data() {
			return {
				SelExamPaperTypeData:[],
				queryPage: {
					current: 1,
					pageSize: 5
				},
				knowCount:0,
				animalCount:0,
				examCount:0,
				knowledgeData:[],
				animalData:[],
				selectedItem: 999,
				examData: [{

						title: '动物房入室考核（三）',
						scope: '总分100分，及格分数60分',
						examTime: '45 min',
						time: '2021-12-14'
					},
					{

						title: '动物房入室考核（二）',
						scope: '总分100分，及格分数60分',
						examTime: '45 min',
						time: '2021-12-14'
					},
					{

						title: '动物房入室考核（一）',
						scope: '总分100分，及格分数60分',
						examTime: '45 min',
						time: '2021-12-14'
					}
				]
			}
		},
		created() {
			this.getSelExamPaperType()
			// this.getAllExamData()
		},
		
		methods:{
			async getSelExamPaperType(){
				const res = await SelExamPaperType()
				this.SelExamPaperTypeData = res.data.data
			},
			getAllExamData(){
				this.getExamData({
					ExamPaperTypeId:4,
					name:window.localStorage.getItem('searchValues'),
					page:this.queryPage.current,
					row:this.queryPage.pageSize,
				})
				this.getExamData({
					ExamPaperTypeId:1,
					name:window.localStorage.getItem('searchValues'),
					page:this.queryPage.current,
					row:this.queryPage.pageSize,
				})
				this.getExamData({
					ExamPaperTypeId:3,
					name:window.localStorage.getItem('searchValues'),
					page:this.queryPage.current,
					row:this.queryPage.pageSize,
				})
			},
		async getExamData(data){
			if(data.ExamPaperTypeId==4){
				let res = await SelExamPaper(data)
				this.examData = res.data.data
				this.examCount = res.data.totalCount
			}
			else if(data.ExamPaperTypeId==1){
				let res = await SelExamPaper(data)
				this.animalData = res.data.data
				this.animalCount = res.data.totalCount
			}
			else if(data.ExamPaperTypeId==3){
				let res = await SelExamPaper(data)
				this.knowledgeData = res.data.data
				this.knowCount = res.data.totalCount
			}	
		},
	
	}
		
	}
</script>

<style scoped>
	.container {
		width: 100%;
		display: flex;
		background-color: #F6F8FA;
		height: 100%;
		min-height: 37.5rem;
		justify-content: center;
		padding-top: 3.75rem;
		padding-bottom: 4.6875rem;
		position: relative;

	}

	.selectedItem {
		background: #1890FF !important;
		color: white;
	}
</style>
